export default "__VITE_PUBLIC_ASSET__b391038b__"